export default __webpack_public_path__ + "static/media/Reader's Sandals of Awakening.e5431d47.jpg";